<script>
  let data;
  import { each } from "svelte/internal";
  import { show } from "./store.js";
  import YourPlan from "./submit_your_plan.svelte";
  let data_mbl = [
    {
      image1: "/images/design_analysis/1.svg",
      heading: "Foundation Design",
      image2: "images/design_analysis/mobile/mbl1.svg",
      bullet: [
        {
          point: "Building Foundations",
        },
        {
          point: "Dynamic/Vibratory Equipment Foundations",
        },
        {
          point: "Specialty Foundations",
        },
        {
          point: "Equipment Foundations",
        },
        {
          point: "Deep Foundation Systems",
        },
      ],
    },
    {
      image1: "/images/design_analysis/2.svg",
      heading: "SPEACIALTY <br> ENGINEERING  & DESIGN",
      image2: "/images/design_analysis/mobile/mbl2.svg",
      bullet: [
        {
          point: "Structural Design of Plant and Industrial Equipment.",
        },
        { point: "Detailed Civil Design of Plants" },
        { point: "Value Engineering" },
        {
          point:
            "Steel, Fabrication, Erection Design of Precast and Prefabricated Structures",
        },
        { point: "Connection Design" },
        { point: "Vibration/Dynamic Analysis" },
        { point: "PIPE Rack Structures & Piping Support System Design" },
        {
          point:
            "Miscellaneous Steel (Stairs, Rails, Ladders, Catwalk, Platforms)",
        },
        { point: "Industrial Buildings & Overhead Crane Buildings" },
        { point: "Design of Steel and Concrete Bridges and Culverts." },
        { point: "Tanks, Bins, Silos, Chimney Designs" },
      ],
    },
    {
      image1: "/images/design_analysis/3.svg",
      heading: "Architectural <br> Design",
      image2: "/images/design_analysis/mobile/mbl3.svg",
      bullet: [
        {
          point: "Architectural Plans, Layouts and Detailed Design",
        },
        { point: "Interior Design" },
        { point: "Landscape Designs" },
        { point: "Building Façade Improvements and Design" },
        { point: "Skylights Design" },
        { point: "Curtain Wall Design" },
        { point: "Town & Urban Planning" },
      ],
    },
    {
      image1: "/images/design_analysis/4.svg",
      heading: "MEP design",
      image2: "/images/design_analysis/mobile/mbl4.svg",
      bullet: [
        {
          point:
            "We offer Complete Solution in MEP for Plants, Industrial, Commercial, Offices, High rise and Multi Story Buildings.",
        },
      ],
    },
    {
      image1: "/images/design_analysis/5.svg",
      heading: "Design of Building <br> Framing Systems",
      image2: "/images/design_analysis/mobile/mbl5.svg",
      bullet: [
        {
          point: "Structural Steel Industrial Buildings & Storage Sheds",
        },
        { point: "Cast in Place Concrete" },
        { point: "Precast & Prestressed Concrete" },
        { point: "Tilt-up Concrete" },
        { point: "Masonry" },
        { point: "Pre-Engineered Buildings" },
        { point: "Modular based Steel and Concrete Structures and Buildings" },
      ],
    },
    {
      image1: "/images/design_analysis/6.svg",
      heading: "Project & Cost <br>Management",
      image2: "/images/design_analysis/mobile/mbl6.svg",
      bullet: [
        {
          point: "Project Management",
        },
        { point: "Time & Cost Management" },
        { point: "Site Supervision Supervision" },
        { point: "Project Scheduling" },
        {
          point:
            "Tenders /Proposal/BOQ /MTO and All Other Construction Documents",
        },
      ],
    },
    {
      image1: "/images/design_analysis/7.svg",
      heading: "Infrastructure <br> Design",
      image2: "/images/design_analysis/mobile/mbl7.svg",
      bullet: [
        {
          point: "Road Design",
        },
        { point: "Grading and Storm Drainage Design " },
        { point: "Land development, Grading and Paving Design" },
        {
          point:
            "Underground Services, Sanitary Sewer and Water Supply Systems Design",
        },
      ],
    },
    {
      image1: "/images/design_analysis/8.svg",
      heading: "Bridge Engineering",
      image2: "/images/design_analysis/mobile/mbl8.svg",
      bullet: [
        { point: "Design of Concrete Bridges" },
        { point: "Box Girder Bridge " },
        { point: "Box Culverts " },
        { point: "Communication Tower Design" },
        { point: "Self-Supported Towers" },
        { point: "Mono Pole Towers " },
        { point: "Guy Mast Towers" },
        { point: "Antenna Supports" },
        { point: "Capacity Analysis of Existing towers" },
      ],
    },
    {
      image1: "/images/design_analysis/9.svg",
      heading: "Construction <br> Engineering",
      image2: "/images/design_analysis/mobile/mbl9.svg",
      bullet: [
        { point: "Temporary Bracing" },
        { point: "Formwork and Scaffolding Design" },
        { point: "Rigging & Lift Planning" },
        { point: "Field Modifications" },
        { point: "Technical site Support to Site Staff" },
      ],
    },
    {
      image1: "/images/design_analysis/10.svg",
      heading: "Review <br> & Modification <br> of Existing Structures",
      image2: "/images/design_analysis/mobile/mbl10.svg",
      bullet: [
        { point: "Expansion Planning" },
        { point: "Design of Reinforcement" },
        { point: "Modifications" },
        { point: "Stability Review of Existing buildings." },
        {
          point:
            "Retrofitting Design for Over stressed / Seismically Damaged Structures.",
        },
      ],
    },
  ];
  function displayPopUp() {
    show.update((n) => n + 1);
    console.log("show", show);
  }
</script>
<div class="mobile">
  <div>
    <p class="p2-mbl">
      We aim to find the most creative, cost-effective solution to every design
      and to keep projects on budget and on time. As a result, we have clients
      happily return to us with their next projects.
    </p>
  </div>
  {#each data_mbl as data, index}
    <div style="display: flex;margin-top: 13.889vw; align-items: baseline;">
      <div>
        <img alt="" class="image1-mbl" src={data.image1} width="100%" />
      </div>
      <div><h2 class="heading-mbl">{@html data.heading}</h2></div>
      <div>
        <img class="image2-mbl" alt="" src={data.image2} width="100%" />
      </div>
    </div>
    <ul style="list-style-type: square;">
      {#each data.bullet as data1}
        <li class="list-mbl">{data1.point}</li>
      {/each}
    </ul>
    <button
      class="submit-button-mbl"
      on:click={() => {
        displayPopUp();
      }}
    >
      Submit your Plan</button
    >
    <img
      alt=""
      class="arrow-mbl"
      src="/images/design_analysis/mobile/arrow_mbl.svg"
    />
    {#if data_mbl.length - 1 != index}
      <hr
        style="width: 81.161vw;border: 1px solid #EAE7E7;margin-top: 5.278vw;margin-bottom: 13.889vw;"
      />
    {:else}
      <div style="margin-bottom: 7.009vw;" />
    {/if}
  {/each}
</div>
<YourPlan />
<style>
  .p2-mbl {
    font-size: 3.889vw;
    width: 79.444vw;
    text-align: center;
    margin-left: 13.22vw;
    font-weight: 400;
    margin-top: 11.215vw;
  }
  .image1-mbl {
    margin-left: 6.667vw;
    width: 18vw;
  }
  .submit-button-mbl {
    display: flex;
    margin-left: 28.333vw;
    margin-top: 4.444vw;
    font-size: 3.333vw;
    color: #ff6d24;
  }
  .heading-mbl {
    font-size: 5vw;
    margin-left: 6.389vw;
    width: 57vw;
  }
  .list-mbl {
    margin-left: 23.5vw;
    width: 63.333vw;
    margin-top: 3vw;
  }
  .list-mbl::marker {
    color: #ff6d24;
  }
  .arrow-mbl {
    display: flex;
    margin-left: 54.722vw;
    margin-top: -2.5vw;
    width: 3.611vw;
  }
</style>
